import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CommonTitleIcon from "@/assets/img/common/commonTitleIcon.png";
import CommonTitleLongIcon from "@/assets/img/lcg/commonTitleLongIcon.png";
const ModuleHeader = ({ title, children, className = "", isLong = false, }) => {
    return (_jsx("div", { className: `relative w-full  h-[0.40rem] ${className}`, style: {
            transformOrigin: "0 0",
        }, children: _jsxs("div", { className: "h-full absolute inset-0  relative overflow-hidden", style: {
                padding: 0,
                boxShadow: "inset 0 0 0 0.0.rem transparent",
            }, children: [_jsx("div", { className: "absolute inset-0 z-0 flex items-center justify-center", style: {
                        height: "100%",
                        transform: "inherit",
                    }, children: _jsx("img", { src: isLong ? CommonTitleLongIcon : CommonTitleIcon, alt: "", style: {
                            width: "100%",
                            height: "0.40rem",
                            maxHeight: "100%",
                            maxWidth: "100%",
                        }, className: "absolute inset-0", onError: () => { } }) }), _jsxs("div", { className: "relative z-10 flex items-center", style: {
                        height: "100%",
                    }, children: [_jsx("div", { className: "flex items-center h-full flex-shrink-0", children: _jsx("span", { className: "text-white font-bold  tracking-wider drop-shadow-lg whitespace-nowrap", style: {
                                    width: "1.70rem",
                                    marginLeft: "0.40rem",
                                    fontFamily: "Source Han Sans CN",
                                    fontSize: "0.18rem",
                                    display: "inline-flex",
                                    alignItems: "center",
                                }, children: title }) }), children && (_jsx("div", { className: "flex items-center space-x-[0.03rem] flex-shrink-0 ml-[0.01rem]", style: {
                                transform: "translateY(0.07rem)",
                            }, children: _jsx("div", { className: "flex items-center space-x-[0.02rem] max-w-md overflow-hidden", children: children }) })), _jsx("div", { className: "flex items-center space-x-[0.03rem] flex-shrink-0", children: _jsx("div", { className: "flex items-center space-x-[0.02rem] max-w-md overflow-hidden" }) })] })] }) }));
};
export default ModuleHeader;
